import { controls,grouped } from "../controls";
const account_pmsbys = {
label: "Account Pmsbys",
pageLabel: "Account Pmsbys",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Account Pmsby Nominees",uid: "account_pmsby_nominees",fastpath:"nominees"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Account Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "account_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts" ,isReadOnly:"edit" ,displayData:{account_display:"account_display",account_uid:"account_uid",gender:"gender",pan:"pan",aadhaar:"aadhaar",mothers_name:"mothers_name",customer_code:"customer_code",religion:"religion",caste:"caste",mobile:"mobile",dob:"dob",customer_type:"customer_type",int_rate:"int_rate",open_date:"open_date",balance:"balance",prin_int:"prin_int",interest:"interest",penal:"charges",min_balance:"min_balance",expiry_date:"expiry_date",maturity_amount:"maturity_amount",close_date:"close_date",kyc_update_date:"kyc_update_date",fd_amount:"fd_amount",interest_date:"last_int_date",premium_amount:"premium_amount"},hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Premium Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "premium_amount",maxlength:18 ,isReadOnly:"edit" ,isReadOnly:true}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Full Name",star:true}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "full_name",width:"col-sm-4",maxlength:100}),
...controls.magicDateLabel({ tab: "account_pmsby_nominees", label: "Date of Birth",target: "dob",star:false}),
...controls.magicDate({ tab: "account_pmsby_nominees", name: "dob", dateType: "ontype",maxDate:'y' }),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Age",star:true}),
...controls.numberOnly({ tab: "account_pmsby_nominees",  placeHolder: "", name: "age",maxlength:200}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Share"}),
...controls.floatOnly({ tab: "account_pmsby_nominees",  placeHolder: "", name: "share",maxlength:6}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Guardian Descn",star:false}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "guardian_descn",maxlength:50}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Account",star:false}),
...controls.oc({ tab: "account_pmsby_nominees", c: "Account", placeHolder: "Account Code", name: "account_code",fastpath: "accounts",hidden:false}),
...controls.showData({ tab: "account_pmsby_nominees", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Relation",star:true}),
...controls.autoComplete({tab: "account_pmsby_nominees", name: "relation_code", width: "col-sm-2",controlType: "Relation"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: ""}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Nominee Doc Type",star:false}),
...controls.oc({ tab: "account_pmsby_nominees", c: "DocumentType", placeHolder: "Nominee Doc Type", name: "nominee_document_type_code",fastpath: "document_types",displayData:{document_type_display:"nominee_document_type_display",document_type_uid:"nominee_document_type_uid"},hidden:false}),
...controls.showData({ tab: "account_pmsby_nominees", displaytype: "capital", data: "nominee_document_type_display"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Doc No",star:false}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "nominee_document_no",maxlength:50}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Guardian Doc Type",star:false}),
...controls.oc({ tab: "account_pmsby_nominees", c: "DocumentType", placeHolder: "Guardian Doc Type", name: "guardian_document_type_code",fastpath: "document_types",displayData:{document_type_display:"guardian_document_type_display",document_type_uid:"guardian_document_type_uid"},hidden:false}),
...controls.showData({ tab: "account_pmsby_nominees", displaytype: "capital", data: "guardian_document_type_display"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Doc No",star:false}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "guardian_document_no",maxlength:50}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Nominee Phone",star:false}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "nominee_phone",maxlength:13}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Guardian Phone",star:false}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "guardian_phone",maxlength:13}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Nominee Address",star:true}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "nominee_address",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "account_pmsby_nominees", label: "Guardian Address",star:false}),
...controls.text({ tab: "account_pmsby_nominees",  placeHolder: "", name: "guardian_address",width:"col-sm-4",maxlength:100}),

...controls.displayText({ tab:"account_pmsby_nominees" ,width:"col-sm-12", label: "" }),
...controls.displayText({ tab:"account_pmsby_nominees" ,width:"col-sm-4", label: "" }),
...controls.button({
tab:"account_pmsby_nominees",
 label: "ADD",
 style: { padding: 0 },
Bcolor: "success",
 onclick: {
  action: "appendToHTMLTable",
  tableNameField: "account_pmsby_nominees",
  requiredField: ["full_name","dob","age","share","guardian_descn","account_code","account_display","account_uid","relation_code","relation_display","relation_uid","document_type_code","document_type_display","document_type_uid","nominee_document_no","document_type_code","document_type_display","document_type_uid","guardian_document_no","nominee_phone","guardian_phone","nominee_address","guardian_address",],
required:["full_name","age","relation_code","relation_display","relation_uid","nominee_address",],
}, width: "col-sm-2"
}),
...controls.button({
tab:"account_pmsby_nominees",
 label: "CLEAR",
 style: { padding: 0 },
Bcolor: "warning",
 onclick: {
  action: "clearForm",
  tableNameField: "account_pmsby_nominees",
  requiredField: ["full_name","dob","age","share","guardian_descn","account_code","account_display","account_uid","relation_code","relation_display","relation_uid","document_type_code","document_type_display","document_type_uid","nominee_document_no","document_type_code","document_type_display","document_type_uid","guardian_document_no","nominee_phone","guardian_phone","nominee_address","guardian_address",]
}, width: "col-sm-2"
}),
{
  tab:"account_pmsby_nominees",
inputType: "table",
  tableTitle: "",
  deletable: true,
  editable: true,
  tableHeaders: [
    { label: "Sr", type: "autoinc" },
    { label: "Full Name", field: "full_name"},
    { label: "Date of Birth", field: "dob", displaytype: "date"},
    { label: "Age", field: "age"},
    { label: "Share", field: "share"},
    { label: "Guardian Descn", field: "guardian_descn"},
    { label: "Account Code", field: "account_code"},
    { label: "Account ", field: "account_display"},
    { label: "Relation Code", field: "relation_code"},
    { label: "Relation ", field: "relation_display"},
    { label: "Document Type Code", field: "document_type_code"},
    { label: "Nominee Doc Type", field: "document_type_display"},
    { label: "Doc No", field: "nominee_document_no"},
    { label: "Document Type Code", field: "document_type_code"},
    { label: "Guardian Doc Type", field: "document_type_display"},
    { label: "Doc No", field: "guardian_document_no"},
    { label: "Nominee Phone", field: "nominee_phone"},
    { label: "Guardian Phone", field: "guardian_phone"},
    { label: "Nominee Address", field: "nominee_address"},
    { label: "Guardian Address", field: "guardian_address"},
  ],
  widths: {
    parent: "col-sm-12",
    children: "col-sm-12"
  },
  name: "account_pmsby_nominees"
},
]
,history:{
perPage: 10,
reportHeader: "Account Pmsbys",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Account Code",accessor: "AccountPMSBY-account-account_code",},
{Header: "Account",accessor: "AccountPMSBY-account-account_display",},
{Header: "Customer Code",accessor: "AccountPMSBY-account-customer-customer_code",},
{Header: "AADHAAR UID",accessor: "AccountPMSBY-account-customer-aadhaar",},
{Header: "AADHAAR UID",accessor: "AccountPMSBY-account-customer-aadhaar",},
]}};
export default account_pmsbys;